import { Controller } from "@hotwired/stimulus";
import collapsibleContainer from "@app/components/common/collapsibleContainer";

export default class extends Controller {
  static targets = ["nokForms", "deleteNextOfKin"]

  connect() {
    collapsibleContainer();
    this._initializeMailingAddress();
  }

  toggleMailingAddress(event) {
    var element = document.getElementById(
      "toggleMailingAddress-" + event.currentTarget.id
    );
    const container = element.nextElementSibling;
    const collapse = element.parentElement.parentElement;

    if (event.currentTarget.value === "Same address as above") {
      container.style.display = "none";
    } else {
      container.style.display = "block";
    }

    collapse.style.maxHeight = collapse.scrollHeight + "px";
  }

  deleteNextOfKin(event) {
    // get current contract id
    let contractId = event.currentTarget.getAttribute("data-contract-id");
    // getting the form to hide
    let element = document.getElementById("nok-form-" + contractId);
    // setting the hidden field of form "delete_next_of_kin" to true to get it in rails app
    let deleteNextOfKin = document.getElementById("delete-next-of-kin-" + contractId);
    deleteNextOfKin.value = true;
    // setting the required inputs of nok form to false (To handle an edge case in which admin tries to delete the form with all nill values)
    let inputs = document.getElementsByClassName("nok-form-input-" + contractId);
    for (let i = 0; i < inputs.length; i++) {
      inputs[i].required = false;
    }
    //hidding the form
    element.classList.add("hidden");

    let addNextOfKinButton = document.getElementById("add-next-of-kin-btn-" + contractId);
    addNextOfKinButton.classList.remove("hidden");
    event.currentTarget.classList.add("hidden");
  }

  addNextOfKin(event) {
    let contractId = event.currentTarget.getAttribute("data-contract-id");
    //getting the form to hide
    let element = document.getElementById("nok-form-" + contractId);
    //setting the hidden field of form "delete_next_of_kin" to true to get it in rails app
    let deleteNextOfKin = document.getElementById("delete-next-of-kin-" + contractId);
    deleteNextOfKin.value = false;
    //setting the required inputs of nok form to false (To handle an edge case in which admin tries to delete the form with all nill values)
    let inputs = document.getElementsByClassName("nok-form-input-" + contractId);
    for (let i = 0; i < inputs.length; i++) {
      inputs[i].required = true;
    }
    //hidding the form
    element.classList.remove("hidden");

    let deleteNextOfKinButton = document.getElementById("delete-next-of-kin-btn-" + contractId);
    deleteNextOfKinButton.classList.remove("hidden");
    event.currentTarget.classList.add("hidden");
  }

  toggleLoadingSpinner(event) {
    event.currentTarget.querySelector("[name='spinner']").classList.toggle("hidden");
  }

  cancel(event) {
    this.toggleLoadingSpinner(event);
  }

  _initializeMailingAddress() {
    const toggle = document.getElementsByClassName("toggleMailingAddress");

    for (let i = 0; i < toggle.length; i++) {
      const container = toggle[i].nextElementSibling;
      if (
        toggle[i].querySelector("input:checked")?.value ===
        "Same address as above"
      ) {
        container.style.display = "none";
      } else {
        container.style.display = "block";
      }
    }
  }
}
